import type {
  WpxTableFeature,
  WpxTableFeatureConfig,
} from "../types/dataTable.types";

import { AppTableFeature } from "@/app/app.enum";

const DEFAULT_WPX_TABLE_FEATURE: WpxTableFeatureConfig = {
  columnDraggable: true,
  enableEnhancedUX: false,
  showSelectedCount: true,
  showTotalCount: true,
};

const WPX_TABLE_FEATURE_CONFIG: Record<WpxTableFeature, WpxTableFeatureConfig> =
  {
    [AppTableFeature.DEFAULT]: DEFAULT_WPX_TABLE_FEATURE,
    [AppTableFeature.CLIENTS]: {
      ...DEFAULT_WPX_TABLE_FEATURE,
      columnDraggable: true,
      enableEnhancedUX: true,
    },
    [AppTableFeature.WORKFORCE]: {
      ...DEFAULT_WPX_TABLE_FEATURE,
      enableEnhancedUX: true,
    },
  };

/**
 * Resolves feature-level table defaults without forcing each consumer to repeat the same prop set.
 *
 * @param {WpxTableFeature | undefined} feature - Feature-specific table variant.
 * @returns {WpxTableFeatureConfig} Resolved variant configuration.
 */
export const resolveWpxTableFeatureConfig = (
  feature: WpxTableFeature | undefined,
): WpxTableFeatureConfig => {
  return WPX_TABLE_FEATURE_CONFIG[feature ?? AppTableFeature.DEFAULT];
};
